import "core-js/modules/es.array.slice.js";
import { defineComponent } from 'vue';
import SwiperContestList from './SwiperContestList.vue';
import { useRouter } from 'vue-router';
import { ArrowRightOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  name: 'SwiperActivitySlide',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    SwiperContestList: SwiperContestList,
    ArrowRightOutlined: ArrowRightOutlined
  },
  setup: function setup(props) {
    var router = useRouter();
    var current = props.data.contestSummaryList[0];
    var slideList = props.data.contestSummaryList.slice(1);

    var checkDetail = function checkDetail() {
      router.push({
        name: 'ItemDetail',
        params: {
          id: current.contestId
        }
      });
    }; // activity/:type/:activityId?/:itemId?/:suffix(s/.+)?


    var checkMore = function checkMore() {
      router.push({
        name: 'ActivityDetail',
        params: {
          type: current.activityTypeCode
        }
      });
    };

    return {
      current: current,
      slideList: slideList,
      checkMore: checkMore,
      checkDetail: checkDetail
    };
  }
});